import { attrTypes } from "../dataFilters";
import { z } from "zod";

export const schema = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  p_name: z.string().min(1),
  icon: z.string(),
  table: z.string().optional(),
  title: z.string().optional(),
  attributes: attrTypes,
});
